module.exports = __webpack_public_path__ + "components/home-header/static/header-7--small@2x-dc0fb34b23c32947655fc22b83503f2d.jpg";